var faq_containers = document.querySelectorAll(".faq-qa__container");
faq_containers.forEach(function (faq_container) {
  faq_container.addEventListener("click", function () {
    faq_container.classList.toggle("open");
  });
});